enum ESocialType {
	twitter = 'twitter',
	telegram = 'telegram',
	discord = 'discord',
	link = 'link'
}

enum ESocialShareType {
	profile = 'profile',
	quest = 'quest',
	app = 'app'
}

export { ESocialShareType, ESocialType };
